// Lib imports
import React, { Component } from 'react';
import { withStyles, Button, Typography, Grid, Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import HelpIcon from "@material-ui/icons/Help";
import moment from 'moment';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
// Custom imports
import SideBar from '../../../../common/components/UI/SideBar/SideBar';

import {
    addPrivateEmployeeProposableShiftsList,
    clearSelectedOpenShifts,
    clearSelectedShifts,
    closeSidePanel,
    updateEmployeeDashboardData,
    updateEmployeeToOfferList,
    resetAndAddEmployeesToOfferList,
    addOrUpdatevalidatedEmployeesToOfferList,
    addOrUpdateEmployeesToOfferList,
    updateEmployeesToOfferList,
    resetValidatedEmployeesToOfferList,
    resetEmployeesToOfferList,
    updateLoading,
    updateLoadingPrivateEmployeesValidation,
    updateLoadingPrivateEmployeesNames,
    updatePartialDates,
    updateSelectedActionIndex,
    updateSnackbar,
    updateSidePanelData,
    updateProposalPartialDates,
} from '../../actions';
import { updateProposalShiftsSelected } from '../../actions/mobileActions';

import { EmployeeDashboardStyles } from '../../../styles/styles';
import { formatShift, handleAPIErrors } from '../../../auxilaries';

import {
    handleAcceptProposal,
    handleDeclineShiftSwap,
    handleDeclineToCover,
    handleOfferShiftToCover,
    handlePrivateSwapOfferShiftWithProposal,
    handleRequestOpenShift,
    handleRequestShift,
    handleRequestVTO,
    handleRetractRequestOpenShift,
    handleRetractRequestVTO,
    handleRetractShiftOffer,
    handleRetractShiftRequest,
    handleRetractShiftSwapProposal,
    handleRetractShiftToSwapOffer,
    handleSnackbar,
    handleSubmitProposal,
    handleSubmitProposalFromOfferor,
    handleSwapOfferShift,
    getAvailableTimeOffRequestForToCover
} from '../Utils/handlers';

import * as Net from '../Utils/dotNet';
import { wrapWithLeftRightGrid } from '../Utils/uiGenerators';
import { generateSelectedPartialLabel, isPartialOfShift } from '../Utils/PartialShiftHelper';
import { RequestSource, RequestStatus, RequestTypes, RequestSubtypes, TorCreationType, PrivateEmployeesRealTimeMessage } from '../../../Enums';
import { ConfirmDialog } from '../../components/core';
import ConfirmDialogContent from '../ConfirmDialogContent';
import './sidePanel.scss';
import { formatAs, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';

class SidePanel extends Component {

    constructor(props) {
        super(props);
        this.currentEmployeeRequestData = null;
    }

    state = {
        employeesSelected: [],
        preferredDatesSelected: [],
        isOpenRecipientEmployees: false,
        isSendToPrivate: false,
        showCommentModal: false,
        showRetractConfirmationModal: false,
        proposalIdSelected: null,
        timeOffRequestReasonIdSelected: null,
        timeOffRequestSubtypeIdSelected: null,
        privateEmployeeWarning: null,
        isSkipValidation: false,
        privateEmployeeFilters: {// TODO: Better to put this in the store
            isExcludeNotTransferred: true,
            searchString: "",
            isShowWarnings: true,
        },
        requestId: null,
    }

    componentDidMount() {
        const { signalRConnection } = this.props;
        updateLoading(false);

        if (signalRConnection) {
            signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeeNames, this.handleReceiveEmployeeNames);
            signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveValidations, this.handleReceiveValidations);
            signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingError, this.handleReceiveEmployeesError);
            signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingWithValidationError, this.handleReceiveValidationError);
        }
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.signalRConnection && this.props.signalRConnection) {
            this.props.signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeeNames, this.handleReceiveEmployeeNames);
            this.props.signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveValidations, this.handleReceiveValidations);
            this.props.signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingError, this.handleReceiveEmployeesError);
            this.props.signalRConnection.on(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingWithValidationError, this.handleReceiveValidationError);
        }
    }

    componentWillUnmount() {
        const { signalRConnection } = this.props;
        if (signalRConnection) {
            signalRConnection.off(PrivateEmployeesRealTimeMessage.ReceiveEmployeeNames);
            signalRConnection.off(PrivateEmployeesRealTimeMessage.ReceiveValidations);
            signalRConnection.off(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingError);
            signalRConnection.off(PrivateEmployeesRealTimeMessage.ReceiveEmployeesForPrivateOfferingWithValidationError);
        }
    }

    handleReceiveEmployeeNames = (employees) => {
        const { updateEmployeesToOfferList, addOrUpdateEmployeesToOfferList, employeesToOfferList, signalRConnection, updateLoadingPrivateEmployeesNames, updateLoadingPrivateEmployeesValidation } = this.props;
        const data = this.currentEmployeeRequestData;

        addOrUpdateEmployeesToOfferList([...employees.map(x => ({ ...x, isValidated: false, isValid: true }))]);
        updateLoadingPrivateEmployeesNames(false);
        updateLoadingPrivateEmployeesValidation(true);

        if (data) {
            data.EmployeeIdsToValidate = employees.map(x => x.employeeId);

            const validatedEmployeesToAdd = employeesToOfferList.validatedEmployees.filter(x => x.isValidated && data.EmployeeIdsToValidate.includes(x.employeeId));
            updateEmployeesToOfferList(validatedEmployeesToAdd);
            const validatedEmployeeToAddIds = validatedEmployeesToAdd.map(x => x.employeeId);
            data.EmployeeIdsToValidate = data.EmployeeIdsToValidate.filter(x => !validatedEmployeeToAddIds.includes(x));

            if (data.EmployeeIdsToValidate?.length > 0) {
                // Wrap data with JWT token for secure SignalR communication
                const secureValidationData = {
                    Token: sessionStorage.getItem('authToken')?.replace('Bearer ', '') || '',
                    EmployeeSearch: data
                };

                signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestEmployeeValidations, this.state.requestId.toString(), secureValidationData)
            } else {
                this.checkAndUpdateLoadingPrivateEmployeesValidation();
            }
        }
    }

    checkAndUpdateLoadingPrivateEmployeesValidation = () => {
        if (this.props.employeesToOfferList.employees.every(x => x.isValidated)) {
            this.props.updateLoadingPrivateEmployeesValidation(false);
        }
    }

    handleReceiveValidations = (employees) => {
        this.props.updateEmployeesToOfferList(employees.map(x => ({ ...x, isValidated: true })));
        this.props.addOrUpdatevalidatedEmployeesToOfferList(employees.map(x => ({ ...x, isValidated: true })));
        this.checkAndUpdateLoadingPrivateEmployeesValidation();
    }

    toggleIsOpenRecipientEmployees = () => {
        const { isOpenRecipientEmployees } = this.state;

        this.setState({
            isOpenRecipientEmployees: !isOpenRecipientEmployees,
        })
    }

    toggleIsSendToPrivate = () => {
        this.setState({
            isSendToPrivate: !this.state.isSendToPrivate,
        })

    }

    resetCommentToManager = () => {
        this.setState({
            showCommentModal: false,
            proposalIdSelected: null,
        })
    }

    showRetractConfirmation = () => {
        this.setState({
            showRetractConfirmationModal: true,
        })
    }

    hideRetractConfirmation = () => {
        this.setState({
            showRetractConfirmationModal: false,
        })
    }

    confirmRetract = () => {
        const { sidePanelData, person } = this.props;
        if (!sidePanelData) {
            this.hideRetractConfirmation();
            return;
        }

        switch (sidePanelData.type) {
            case RequestTypes.toCover:
                if (sidePanelData.source === RequestSource.Offerer) {
                    this.handleRetractShiftOffer(sidePanelData);
                } else {
                    this.handleRetractShiftRequest(sidePanelData);
                }
                break;
            case RequestTypes.shiftSwap:
                if (sidePanelData.source === RequestSource.Offerer) {
                    this.handleRetractShiftToSwapOffer(sidePanelData);
                } else {
                    const found = sidePanelData.proposals?.find(proposal =>
                        proposal.proposalEmployeeId === person.currentEmployeeId &&
                        (proposal.status === RequestStatus.Offered || proposal.status === RequestStatus.Submitted)
                    );
                    if (found) {
                        this.handleRetractShiftSwapProposal(sidePanelData, found.proposalId);
                    }
                }
                break;
            case RequestTypes.openShift:
                this.handleRetractRequestOpenShift(sidePanelData.offerId);
                break;
            case RequestTypes.voluntaryTimeOff:
                handleRetractRequestVTO.bind(this)(sidePanelData.offerId);
                break;
            default:
                break;
        }

        this.hideRetractConfirmation();
    }

    onTogglePrivateEmployees = () => {
        const { isSendToPrivate, requestId } = this.state

        if (isSendToPrivate) {//switch Send to billboard
            this.resetSendToPrivate();
            this.props.signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestCancelTask, requestId.toString());
        }
        else {
            this.toggleIsSendToPrivate()
            this.fetchPrivateEmployees()
                .catch(() => this.resetSendToPrivate())
        }
        this.setState({
            privateEmployeeWarning: null,
        })
    }


    resetSendToPrivate = () => {
        const { resetValidatedEmployeesToOfferList } = this.props;
        this.setState({
            privateEmployeeWarning: null,
            isSendToPrivate: false,
            employeesSelected: [],
            privateEmployeeFilters: {
                isExcludeNotTransferred: true,
                searchString: "",
                isShowWarnings: true,
            }
        });
        resetValidatedEmployeesToOfferList();
    }

    handleFilterChange = async (updatedFilters) => {
        const { employeesToOfferList, resetAndAddEmployeesToOfferList, signalRConnection } = this.props;
        const { privateEmployeeFilters, requestId } = this.state;
        const { isShowWarnings: currentIsShowWarnings, isExcludeNotTransferred: currentIsExcludeNotTransferred } = privateEmployeeFilters;
        let { isShowWarnings: nextIsShowWarnings, isExcludeNotTransferred: nextIsExcludeNotTransferred } = updatedFilters;
        let willCallFetchPrivateEmployees = true;

        if (currentIsShowWarnings != (nextIsShowWarnings ?? currentIsShowWarnings)) {
            willCallFetchPrivateEmployees = false;
        }
        nextIsExcludeNotTransferred = nextIsExcludeNotTransferred ?? currentIsExcludeNotTransferred
        if (currentIsExcludeNotTransferred != (nextIsExcludeNotTransferred)) {
            if (nextIsExcludeNotTransferred) {//will filter already loaded list
                signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestCancelTask, requestId.toString());
                const filtered = employeesToOfferList.validatedEmployees.filter(e => e.isPjAndJtsEmployee);
                resetAndAddEmployeesToOfferList(filtered);
                willCallFetchPrivateEmployees = false;
            }
        }

        this.setState(
            { privateEmployeeFilters: { ...this.state.privateEmployeeFilters, ...updatedFilters } },
            async () => {
                if (willCallFetchPrivateEmployees) {
                    await this.fetchPrivateEmployees();
                }
            }
        );
    };

    /**
     * 
     * @param {string} searchString 
     * @param {bool?} shouldResetList 
     */
    fetchPrivateEmployees = async () => {
        const { privateEmployeeFilters, requestId } = this.state;
        const {
            resetEmployeesToOfferList, updateLoadingPrivateEmployeesNames,
            updateLoadingPrivateEmployeesValidation, sidePanelData, selectedActionIndex, billboardActions, partialDates, signalRConnection
        } = this.props;
        const searchString = privateEmployeeFilters.searchString ?? "";
        updateLoadingPrivateEmployeesNames(true);
        updateLoadingPrivateEmployeesValidation(true);

        let selected = billboardActions[selectedActionIndex];
        let isPartial = false;
        let partialStartDate, partialEndDate = null;
        if (isPartialOfShift(partialDates, sidePanelData.shifts[0])) {
            isPartial = true;
            partialStartDate = partialDates.startDate;
            partialEndDate = partialDates.endDate;
        }

        if (requestId) {
            signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestCancelTask, requestId.toString());
            resetEmployeesToOfferList();
        }

        const data = {
            ManagerSettingId: selected.guid,
            Shifts: sidePanelData.shifts,
            SearchString: searchString.trim(),
            IsPartial: isPartial,
            PartialStartDate: partialStartDate,
            PartialEndDate: partialEndDate,
            IsShowPjAndJtsEmployeesOnly: privateEmployeeFilters.isExcludeNotTransferred,
        };
        try {
            this.currentEmployeeRequestData = data;
            const newRequestId = Math.random();
            this.setState({
                requestId: newRequestId,
            })

            // Wrap data with JWT token for secure SignalR communication
            const secureData = {
                Token: sessionStorage.getItem('authToken')?.replace('Bearer ', '') || '',
                EmployeeSearch: data
            };

            signalRConnection.send(PrivateEmployeesRealTimeMessage.RequestEmployeeNames, newRequestId.toString(), secureData);
        } catch (error) {
            if (error.name === "AbortError") {
                console.log('AbortError 3: ' + error.message);
            } else {
                console.error("Error during fetch():", error);
                this.handleSnackbar('error', error.toString(), true);
            }
            updateLoadingPrivateEmployeesNames(false);
            updateLoadingPrivateEmployeesValidation(false);
        }
    }

    validateEmployeePriority = async (employeeId) => {
        const {
            options,
            updateEmployeesToOfferList,
            addOrUpdatevalidatedEmployeesToOfferList,
            sidePanelData,
            selectedActionIndex,
            billboardActions,
            partialDates,
        } = this.props;
        const { privateEmployeeFilters } = this.state;

        let selected = billboardActions[selectedActionIndex];
        let isPartial = false;
        let partialStartDate, partialEndDate = null;
        if (isPartialOfShift(partialDates, sidePanelData.shifts[0])) {
            isPartial = true;
            partialStartDate = partialDates.startDate;
            partialEndDate = partialDates.endDate;
        }

        const data = {
            ManagerSettingId: selected.guid,
            Shifts: sidePanelData.shifts,
            SearchString: privateEmployeeFilters.searchString.trim(),
            IsPartial: isPartial,
            PartialStartDate: partialStartDate,
            PartialEndDate: partialEndDate,
            IsShowPjAndJtsEmployeesOnly: privateEmployeeFilters.isExcludeNotTransferred,
            EmployeeIdsToValidate: [employeeId]
        };

        try {
            const response = await fetch(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/dashboard/GetAvailableEmployeesForPrivateOfferingWithValidation", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": sessionStorage.getItem('authToken') ?? '',
                    ...options,
                },
                body: JSON.stringify(data),
            });
            const reader = response.body?.getReader();
            const decoder = new TextDecoder();
            if (reader) {
                while (true) {
                    const { done, value } = await reader.read();
                    if (done) break;
                    const chunk = decoder.decode(value, { stream: true });
                    const lines = chunk.split("\n").filter(Boolean);
                    lines.forEach(line => {
                        try {
                            const item = JSON.parse(line);
                            updateEmployeesToOfferList(item.map(x => ({ ...x, isValidated: true })));
                            addOrUpdatevalidatedEmployeesToOfferList(item.map(x => ({ ...x, isValidated: true })));
                            this.checkAndUpdateLoadingPrivateEmployeesValidation();
                        } catch (err) {
                            console.log('Error parsing priority validation line:', err.message);
                            this.handleSnackbar('error', 'Failed to validate employees', true);
                            return;
                        }
                    });
                }
            }
        } catch (err) {
            console.log('Error validating employee in priority:', err);
            this.handleSnackbar('error', 'Failed to validate employees', true);
            return;
        }
    }

    fetchPrivateEmployeeProposableShifts = async (employeeId, isSkipValidation) => {
        const {
            options,
            updateLoading,
            sidePanelData,
            selectedActionIndex,
            billboardActions,
            addPrivateEmployeeProposableShiftsList,
            proposableShiftsPerEmployee,
            partialDates,
        } = this.props;

        let selected = billboardActions[selectedActionIndex];

        updateLoading(true);
        try {
            let partialStartDate, partialEndDate = null;
            if (isPartialOfShift(partialDates, sidePanelData.shifts[0])) {
                partialStartDate = partialDates.startDate;
                partialEndDate = partialDates.endDate;
            }
            const employeesResponse = await Net.getEligiblePrivateEmployeeSchedule(options, sidePanelData.shifts, selected.guid, selected.value, employeeId, partialStartDate, partialEndDate, isSkipValidation);
            let updatedProposableShiftsPerEmployee = proposableShiftsPerEmployee;
            updatedProposableShiftsPerEmployee[employeeId] = employeesResponse.data;
            addPrivateEmployeeProposableShiftsList(updatedProposableShiftsPerEmployee);
            return employeesResponse.data;
        } catch (ex) {
            const message = handleAPIErrors(ex.response);
            handleSnackbar.bind(this)('error', message, true);
            return;
        } finally {
            updateLoading(false);
        }
    }

    resetCollapsibles() {
        this.setState({
            employeesSelected: [],
            preferredDatesSelected: [],
            isOpenRecipientEmployees: false,
            isSendToPrivate: false,
            showCommentModal: false,
            showRetractConfirmationModal: false,
            proposalIdSelected: null,
            timeOffRequestReasonIdSelected: null,
            timeOffRequestSubtypeIdSelected: null,
            privateEmployeeWarning: null,
            isSkipValidation: false,
            filters: {//TODO - remove?
                isExcludeNotTransferred: true,
            },
            privateEmployeeFilters: {
                isExcludeNotTransferred: true,
                searchString: "",
                isShowWarnings: true,
            }
        });
    }

    resetSidePanel() {
        this.props.refreshManagerSettings();
        this.props.resetValidatedEmployeesToOfferList();
        this.resetCollapsibles();
        this.props.closeSidePanel();
    }

    handleSubmitSidePanel = () => {
        const { managerSettings, selectedActionIndex, billboardActions, selectedProposableShiftsByOfferor, sidePanelData } = this.props
        if (selectedActionIndex < 0) {
            handleSnackbar.bind(this)('error', 'Select an action', true)
            return
        }

        // Find the selected manager setting
        let selectedManagerSetting = managerSettings.find(setting => setting.id === billboardActions[selectedActionIndex].value)

        if (this.state.isSendToPrivate && !selectedManagerSetting.isAllowProposalWithOffer && !this.state.employeesSelected.length) {
            handleSnackbar.bind(this)('error', 'Select at least one recipient!', true)
            return
        }

        if (this.state.isSendToPrivate && selectedManagerSetting.isAllowProposalWithOffer) {
            if (!selectedProposableShiftsByOfferor.employee.employeeId || !selectedProposableShiftsByOfferor.shifts.length) {
                handleSnackbar.bind(this)('error', 'Select at least one recipient and at least one shift to propose!', true)
                return;
            }
            else if (selectedProposableShiftsByOfferor.shifts.length !== sidePanelData.shifts.length) {
                handleSnackbar.bind(this)('error', 'The number of shifts offered must match the number of shifts proposed', true)
                return;
            }
        }

        const validation = selectedManagerSetting.workedHoursValidation
        if (validation && !validation.isValid) {
            handleSnackbar.bind(this)('error', `Worked hours requirements not met. Required time worked between ${formatAs(validation.startDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)}
            and ${formatAs(validation.endDate, DateFnsFormats.VERBOSE_LONG_DATE_FORMAT)} is ${validation.requiredHours} hours. Hours worked during that period: ${validation.workedHours}.
            `, true)
            return
        }
        // Determine the action type
        switch (selectedManagerSetting.type) {
            case RequestTypes.toCover:
                this.handleOfferShiftToCover(selectedManagerSetting)
                break;
            case RequestTypes.shiftSwap:
                this.handleSwapOfferShift(selectedManagerSetting, this.state.isSendToPrivate)
                break;
            default:
                console.log('Action not defined');
                return;
        }
    }

    // To cover handlers
    handleOfferShiftToCover = (selectedManagerSetting) => {
        const { sidePanelData, partialDates } = this.props;
        const { employeesSelected, timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected } = this.state;
        handleOfferShiftToCover.bind(this)(selectedManagerSetting, sidePanelData.shifts, partialDates, employeesSelected, timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected)
        this.resetSidePanel()
    }

    handleRetractShiftOffer = (offer) => {
        handleRetractShiftOffer.bind(this)(offer)
        this.props.closeSidePanel()
    }

    handleRequestShift = async (value, commentToManager) => {
        await handleRequestShift.bind(this)(value, commentToManager);
        this.props.closeSidePanel();
    }

    handleRetractShiftRequest = async (offer) => {
        await handleRetractShiftRequest.bind(this)(offer)
        this.props.closeSidePanel()
    }
    // End to cover handlers
    // Shift swap handlers
    handleSwapOfferShift = (selectedManagerSetting, isSendToPrivate) => {
        const { employeesSelected, preferredDatesSelected } = this.state
        const { sidePanelData, selectedProposableShiftsByOfferor, partialDates, proposalPartialDates } = this.props
        const { employee, shifts } = selectedProposableShiftsByOfferor;
        if (selectedManagerSetting.isAllowProposalWithOffer && isSendToPrivate) {
            handlePrivateSwapOfferShiftWithProposal.bind(this)(
                selectedManagerSetting,
                employee.employeeId,
                sidePanelData.shifts,
                shifts,
                partialDates,
                proposalPartialDates,
            );
        }
        else {
            handleSwapOfferShift.bind(this)(selectedManagerSetting, employeesSelected, preferredDatesSelected, sidePanelData.shifts, partialDates)
        }
        this.resetSidePanel()
    }

    handleRetractShiftToSwapOffer = (offer) => {
        handleRetractShiftToSwapOffer.bind(this)(offer)
        this.props.closeSidePanel()
    }

    handleProposeShiftSwapOffer = (offer, shiftsInfo) => {
        const { closeSidePanel, proposalPartialDates } = this.props;
        handleSubmitProposal.bind(this)(offer, shiftsInfo, proposalPartialDates).then(() => {
            closeSidePanel();
            return;
        })
    }

    handleAcceptProposalFromShiftSwapOffer = (offer, proposal, commentToManager) => {
        handleSubmitProposalFromOfferor.bind(this)(offer, proposal, commentToManager)
        this.props.closeSidePanel()
    }

    handleRetractShiftSwapProposal = (selectedOffer, proposal) => {
        handleRetractShiftSwapProposal.bind(this)(selectedOffer, proposal)
        this.props.closeSidePanel()
    }
    // End shift swap handlers
    // Open shift handlers
    handleRequestOpenShift = async (data, commentToManager) => {
        handleRequestOpenShift.bind(this)(data.raw, commentToManager, data.isPartialShiftEnabled, this.props.partialDates);
        this.props.closeSidePanel()
        this.props.clearSelectedOpenShifts()
    }

    handleRetractRequestOpenShift = (requestId) => {
        handleRetractRequestOpenShift.bind(this)(requestId)
        this.props.closeSidePanel()
    }
    // End open shift handlers

    retrieveAvailableTimeOffRequestForToCover = (index, partialStartDate, partialEndDate) => {
        const { billboardActions, managerSettings, sidePanelData } = this.props
        const selectedManagerSetting = managerSettings.find(setting => setting.id === billboardActions[index]?.value)

        if (!selectedManagerSetting
            || selectedManagerSetting?.type !== RequestTypes.toCover
            || !selectedManagerSetting.isConditionalTimeOffRequestAutoApprovalEnabled) {
            return;
        }

        if (sidePanelData.shifts.length === 1) {
            const data = {
                shift: sidePanelData.shifts[0],
                adminSettingId: selectedManagerSetting.adminSettingsId
            };

            if (selectedManagerSetting.isPartialShiftEnabled && partialStartDate && partialEndDate) {
                if (!(moment.utc(partialStartDate).isSame(moment.utc(sidePanelData.shifts[0].startDateTime))
                    && moment.utc(partialEndDate).isSame(moment.utc(sidePanelData.shifts[0].endDateTime)))) {

                    data.isPartial = true;
                    data.partialStartDate = partialStartDate.toDate();
                    data.partialEndDate = partialEndDate.toDate();
                }
            }

            getAvailableTimeOffRequestForToCover.bind(this)(data);
        }
    }

    handleSubmitActionType = (selected) => {
        const { billboardActions, updateSelectedActionIndex, updateSidePanelData, resetValidatedEmployeesToOfferList } = this.props;
        if (!selected) {
            return;
        }
        let index = billboardActions.findIndex(ele => ele.value === selected.value);
        const selectedManagerSetting = selected;

        updateSidePanelData({ timeOffRequest: null, timeOffRequestError: null });
        resetValidatedEmployeesToOfferList();
        if (selectedManagerSetting.isConditionalTimeOffRequestAutoApprovalEnabled) {
            this.retrieveAvailableTimeOffRequestForToCover(index);
        }
        updateSelectedActionIndex(index)
        this.resetCollapsibles()
    }

    handleChangePartial = (e, val, shifts, type) => {
        const { selectedActionIndex, updatePartialDates } = this.props;
        let shift = shifts[0];
        let startDate = moment.utc(shift.startDateTime);
        let newStartDate = moment.utc(startDate).add(val[0], 'm')
        let newEndDate = moment.utc(startDate).add(val[1], 'm')
        let partialShiftLabel = generateSelectedPartialLabel(shift, newStartDate, newEndDate, type)

        this.retrieveAvailableTimeOffRequestForToCover(selectedActionIndex, newStartDate, newEndDate);
        updatePartialDates({
            startDate: newStartDate,
            endDate: newEndDate,
            partialShiftLabel: partialShiftLabel,
        });
        this.resetSendToPrivate();
    }

    handleSelectProposal = (pId) => {
        this.setState({
            proposalIdSelected: pId,
            showCommentModal: true,
        });
    }

    handleSnackbar = (type, message, openState) => {
        this.props.updateSnackbar({
            typeSnackbar: type,
            messageSnackbar: message,
            openSnackbar: openState,
        })
    }

    handleChangeIsSkipValidation = async (event, offerId) => {
        const checked = event.target.checked;
        await this.props.updateProposalShiftsSelected([]);
        await this.props.fetchAndUpdateShifts(offerId, checked);
        this.setState({ isSkipValidation: checked });
    };

    generateSidePanelContent = (data) => {
        const { showCommentModal, showRetractConfirmationModal, proposalIdSelected, timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected, privateEmployeeWarning } = this.state;
        const { classes, partialDates, person, t, sidePanelData } = this.props;

        let shiftsArray = [];
        let useLeftContainer = false;
        // Generate buttons
        switch (data.type) {
            case -1: // Shifts action
                useLeftContainer = true;
                break;
            case RequestTypes.toCover:
                break;
            case RequestTypes.shiftSwap:
                useLeftContainer = true;
                if (data.status === RequestStatus.Offered && data.source === RequestSource.Requester) {
                    shiftsArray = formatShift(this.props.validProposalShifts)
                }
                if (data.status === RequestStatus.Submitted
                    && (
                        !data.proposals.length
                        || !data.proposals.some(x => [RequestStatus.Submitted, RequestStatus.Pending].includes(x.status))
                    )
                ) {//not my submission
                    useLeftContainer = false;
                }
                break;
            case RequestTypes.openShift:
                if (data.isPartialShiftEnabled) {
                    useLeftContainer = true;
                }
                break;
            default:
                break;
        }
        let button = this.generateSidePanelSubmitButton(data)
        let content = wrapWithLeftRightGrid.bind(this)(
            data,
            classes,
            useLeftContainer,
            button,
            shiftsArray,
            partialDates.partialShiftLabel,
            this.handleChangePartial,
            timeOffRequestSubtypeIdSelected,
            timeOffRequestReasonIdSelected,
            (id) => this.setState({ timeOffRequestSubtypeIdSelected: id }),
            (id) => this.setState({ timeOffRequestReasonIdSelected: id }),
            privateEmployeeWarning,
            (warning) => this.setState({ privateEmployeeWarning: warning }),
            this.handleFilterChange,
        );
        const handleSubmitCommentModal = (msg) => {
            switch (data.type) {
                case RequestTypes.toCover:
                    this.handleRequestShift(data, msg);
                    break;
                case RequestTypes.shiftSwap: {
                    if (data.raw.isPrivate && data.raw.isProposedByOfferer && data.raw.proposals.some(x => x.status === RequestStatus.Offered)) {
                        const proposal = data.raw.proposals.find(x => x.status === RequestStatus.Offered);
                        this.handleAcceptProposalFromShiftSwapOffer(data, proposal, msg);
                        break;
                    }
                    handleAcceptProposal(this, proposalIdSelected, data, msg);
                    break;
                }
                case RequestTypes.openShift:
                    this.handleRequestOpenShift(data, msg);
                    break;
                case RequestTypes.voluntaryTimeOff:
                    handleRequestVTO.bind(this)(data.offerId, msg);
                    break;
                default:
                    return null;
            }
            this.resetCommentToManager();
        }
        return (
            <>
                {content}
                <ConfirmDialog
                    open={showCommentModal}
                    onCancel={this.resetCommentToManager}
                    onConfirm={(msg) => handleSubmitCommentModal(msg)}
                >
                    <ConfirmDialogContent
                        request={{ ...data, proposalIdSelected, partialDates }}
                        person={person}
                    />
                </ConfirmDialog>

                {showRetractConfirmationModal && (
                    <ConfirmDialog
                        title={sidePanelData && (sidePanelData.status === RequestStatus.Submitted || sidePanelData.status === RequestStatus.Pending)
                            ? t("employeeSidePanel.retractPopup.retractRequest")
                            : t("employeeSidePanel.retractPopup.retractOffer")}
                        header={sidePanelData && (sidePanelData.status === RequestStatus.Submitted || sidePanelData.status === RequestStatus.Pending)
                            ? t("employeeSidePanel.retractPopup.headerRequest")
                            : t("employeeSidePanel.retractPopup.headerOffer")}
                        showTextField={false}
                        open={showRetractConfirmationModal}
                        onCancel={this.hideRetractConfirmation}
                        onConfirm={this.confirmRetract}
                    />
                )}
            </>
        );
    }

    generateSidePanelSubmitButton = (selectedOffer) => {
        const { classes, person, selectedActionIndex, managerSettings, billboardActions, timeOffRequestSubtypes, mobileProposalShiftsSelected, t, isSkipValidation } = this.props;
        const { timeOffRequestSubtypeIdSelected, timeOffRequestReasonIdSelected } = this.state;
        const selectedManagerSetting = managerSettings.find(setting => setting.id === billboardActions[selectedActionIndex]?.value)
        const managerSettingOfSelectedOffer = managerSettings.find(setting => setting.id === selectedOffer?.raw?.managerSettingId)
        const isTimeOffRequestValid = !(selectedManagerSetting?.isConditionalTimeOffRequestAutoApprovalEnabled && !selectedOffer?.timeOffRequest?.id);
        const isTimeOffRequestSubtypeInvalid = () => {
            if (!!selectedManagerSetting && selectedManagerSetting.timeOffRequestCreationType === TorCreationType.None) {
                return false;
            }
            if (!!selectedManagerSetting && selectedManagerSetting.timeOffRequestCreationType === TorCreationType.Required && !timeOffRequestSubtypeIdSelected) {
                return true;
            }

            if (timeOffRequestSubtypeIdSelected) {
                if (!timeOffRequestReasonIdSelected) {
                    return true;
                }
                const selectedSubtype = timeOffRequestSubtypes.find(x => x.id === timeOffRequestSubtypeIdSelected);
                const isInvalidReasonId = selectedSubtype && !selectedSubtype.reasons.some(x => x.id === timeOffRequestReasonIdSelected);
                return isInvalidReasonId;
            }
            return false;
        }

        let button = null;
        switch (selectedOffer.type) {
            case -1:
                button = <Button mt={1} disabled={selectedActionIndex < 0 || !isTimeOffRequestValid || isTimeOffRequestSubtypeInvalid()} className={classes.buttonSubmit} style={{ padding: '10px 30px' }} onClick={() => this.handleSubmitSidePanel()}>
                    <Typography className={classes.SideBarSubmitText} style={{ fontSize: 14 }}>{t('employeeSidePanel.buttons.submit')}</Typography>
                </Button>
                break;
            case RequestTypes.toCover:
                switch (selectedOffer.status) {
                    case RequestStatus.Offered:
                        if (selectedOffer.source === RequestSource.Offerer) {
                            button = <Button mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.showRetractConfirmation()}>
                                <Typography className={classes.SideBarSubmitText}>{t('employeeSidePanel.buttons.retractOffer')}</Typography>
                            </Button>
                        } else {
                            button = selectedOffer.raw.isPrivate ?
                                <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Button mt={1} fullWidth disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.setState({ showCommentModal: true })}>
                                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.acceptRequest')}</Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Button mt={1} fullWidth className={classes.buttonSubmit} onClick={() => handleDeclineToCover.bind(this)(selectedOffer.offerId)}>
                                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.declineOffer')}</Typography>
                                        </Button>
                                    </Grid>
                                </Grid> :
                                <Grid container spacing={2}>
                                    <Grid item xs={6} />
                                    <Grid item xs={6}>
                                        <Button mt={1} fullWidth disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.setState({ showCommentModal: true })}>
                                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.acceptRequest')}</Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                        }
                        break;
                    case RequestStatus.Submitted:
                    case RequestStatus.Pending:
                        if (selectedOffer.source === RequestSource.Offerer) {
                            button = <Button mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.showRetractConfirmation()}>
                                <Typography className={classes.SideBarSubmitText}>{t('employeeSidePanel.buttons.retractOffer')}</Typography>
                            </Button>
                        }
                        else if (selectedOffer.source === RequestSource.Requester) {
                            if ((selectedOffer.raw.isMySubmission && selectedOffer.raw.isPrivate) || !selectedOffer.raw.isPrivate) {
                                button = <Button mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.showRetractConfirmation()}>
                                    <Typography className={classes.SideBarSubmitText}>{t('employeeSidePanel.buttons.retractRequest')}</Typography>
                                </Button>
                            }
                        }
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.shiftSwap:
                switch (selectedOffer.status) {
                    case RequestStatus.Offered:
                        if (selectedOffer.source === RequestSource.Offerer) {
                            button = <Button mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.showRetractConfirmation()}>
                                <Typography className={classes.SideBarSubmitText}>{t('employeeSidePanel.buttons.retractOffer')}</Typography>
                            </Button>
                        } else {//available offer, myProposals
                            if (selectedOffer.raw.isAvailableOffer
                                || (selectedOffer.raw.isPrivate
                                    && !selectedOffer.raw.isProposedByOfferer
                                    && selectedOffer.raw.proposals.every(x => ![RequestStatus.Offered, RequestStatus.Submitted, RequestStatus.Pending].includes(x.status)))
                            ) {
                                button = selectedOffer.raw.isPrivate ? <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Button fullWidth mt={1} disabled={!selectedOffer.raw.isSkipValidation && !selectedOffer.isValid} className={selectedOffer.isValid || selectedOffer.raw.isSkipValidation ? classes.buttonSubmit : classes.buttonDisabled}
                                            onClick={() => {
                                                let found = mobileProposalShiftsSelected.map((shiftSelected) => this.props.validProposalShifts.find(validProposalShift => validProposalShift.id === shiftSelected.id))
                                                this.handleProposeShiftSwapOffer(selectedOffer, found);
                                            }}>
                                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.confirmProposal')}</Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Button mt={1} fullWidth className={classes.buttonSubmit} onClick={() => handleDeclineShiftSwap.bind(this)(selectedOffer.offerId)}>
                                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.declineOffer')}</Typography>
                                        </Button>
                                    </Grid>
                                    {managerSettingOfSelectedOffer.isPartialShiftEnabled ? <Grid
                                        container
                                        xs={12}
                                        justifyContent="flex-end"
                                        alignItems="center"
                                        style={{ marginTop: "15px" }}
                                    >
                                        <FormControlLabel
                                            label={t('employeeSidePanel.showAll')}
                                            labelPlacement="start"
                                            control={
                                                <Checkbox
                                                    color="primary"
                                                    checked={isSkipValidation}
                                                    onChange={(event) => this.handleChangeIsSkipValidation(event, selectedOffer.offerId)}
                                                />
                                            }
                                        />
                                        <Tooltip
                                            title={
                                                <>
                                                    {t(
                                                        "employeeSidePanel.showAllToolTip"
                                                    )}
                                                </>
                                            }
                                            arrow
                                        >
                                            <HelpIcon
                                                fontSize="small"
                                                style={{ width: 42, marginBottom: 8 }}
                                            />
                                        </Tooltip>
                                    </Grid> : null}
                                </Grid> :
                                    <Grid container spacing={2}>
                                        <Grid item xs={6} />
                                        <Grid item xs={6}>
                                            <Button fullWidth mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled}
                                                onClick={() => {
                                                    let found = mobileProposalShiftsSelected.map((shiftSelected) => this.props.validProposalShifts.find(validProposalShift => validProposalShift.id === shiftSelected.id))
                                                    this.handleProposeShiftSwapOffer(selectedOffer, found);
                                                }}>
                                                <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.confirmProposal')}</Typography>
                                            </Button>
                                        </Grid>
                                        {managerSettingOfSelectedOffer.isPartialShiftEnabled ? <Grid
                                            container
                                            xs={12}
                                            justifyContent="flex-end"
                                            alignItems="center"
                                            style={{ marginTop: "15px" }}
                                        >
                                            <FormControlLabel
                                                label={t('employeeSidePanel.showAll')}
                                                labelPlacement="start"
                                                control={
                                                    <Checkbox
                                                        color="primary"
                                                        checked={isSkipValidation}
                                                        onChange={(event) => this.handleChangeIsSkipValidation(event, selectedOffer.offerId)}
                                                    />
                                                }
                                            />
                                            <Tooltip
                                                title={
                                                    <>
                                                        {t(
                                                            "employeeSidePanel.showAllToolTip"
                                                        )}
                                                    </>
                                                }
                                                arrow
                                            >
                                                <HelpIcon
                                                    fontSize="small"
                                                    style={{ width: 42, marginBottom: 8 }}
                                                />
                                            </Tooltip>
                                        </Grid> : null}
                                    </Grid>
                            }
                            else if (selectedOffer.raw.isPrivate && selectedOffer.raw.isProposedByOfferer && selectedOffer.raw.proposals.some(x => x.status === RequestStatus.Offered)) {
                                button = <Grid container spacing={2}>
                                    <Grid item xs={6}>
                                        <Button fullWidth mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled}
                                            onClick={() => this.setState({ showCommentModal: true })}>
                                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.acceptOffer')}</Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Button mt={1} fullWidth className={classes.buttonSubmit} onClick={() => handleDeclineShiftSwap.bind(this)(selectedOffer.offerId)}>
                                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.declineOffer')}</Typography>
                                        </Button>
                                    </Grid>
                                </Grid>
                            }
                            else {
                                let found = selectedOffer.proposals.find((proposal) => (
                                    proposal.proposalEmployeeId === person.currentEmployeeId
                                    && (+proposal.status) !== RequestStatus.OfferRetracted
                                    && (+proposal.status) !== RequestStatus.AutoRetracted
                                ));

                                if (found) {
                                    if (found.status === RequestStatus.Offered || found.status === RequestStatus.Submitted) {
                                        button = <Button mt={1} className={classes.buttonSubmit}
                                            onClick={() => this.showRetractConfirmation()}
                                        >
                                            <Typography className={classes.SideBarSubmitText}>{t('employeeSidePanel.buttons.retractProposal')}</Typography>
                                        </Button>
                                    }
                                }
                            }
                        }
                        break;
                    case RequestStatus.Submitted:
                    case RequestStatus.Pending:
                        if (selectedOffer.source === RequestSource.Offerer) {
                            button = <Button mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.showRetractConfirmation()}>
                                <Typography className={classes.SideBarSubmitText}>{t('employeeSidePanel.buttons.retractOffer')}</Typography>
                            </Button>
                        } else {
                            let found = selectedOffer.proposals.find(proposal => proposal.proposalEmployeeId === person.currentEmployeeId
                                && [RequestStatus.Offered, RequestStatus.Submitted, RequestStatus.Pending].includes(proposal.status))
                            if (found) {
                                button = <Button mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled}
                                    onClick={() => this.showRetractConfirmation()}
                                >
                                    <Typography className={classes.SideBarSubmitText}>{t('employeeSidePanel.buttons.retractProposal')}</Typography>
                                </Button>
                            }

                        }
                        break;
                    default:
                        break;
                }
                break;
            case RequestTypes.openShift:
                if (selectedOffer.source === RequestSource.Requester) {
                    button = <Button mt={1} className={classes.buttonSubmit} onClick={() => this.setState({ showCommentModal: true })}>
                        <Typography className={classes.SidePanelButtonText}>
                            {selectedOffer.requestSubtype === RequestSubtypes.signUp ? t('employeeSidePanel.buttons.submitSignUp') : t('employeeSidePanel.buttons.submitRequest')}
                        </Typography>
                    </Button>
                } else {
                    let statuses = [RequestStatus.Submitted, RequestStatus.Pending]
                    if (statuses.includes(selectedOffer.status)) {
                        button = <Button mt={1} className={classes.buttonSubmit} onClick={() => this.showRetractConfirmation()}>
                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.retractRequest')}</Typography>
                        </Button>
                    }
                }
                break;
            case RequestTypes.voluntaryTimeOff:
                if (selectedOffer.source === RequestSource.Requester) {
                    button = <Button mt={1} disabled={!selectedOffer.isValid} style={{ padding: '10px 20px' }} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.setState({ showCommentModal: true })}>
                        <Typography className={classes.SidePanelButtonText}>
                            {selectedOffer.requestSubtype === RequestSubtypes.signUp ? t('employeeSidePanel.buttons.submitSignUp') : t('employeeSidePanel.buttons.submitRequest')}
                        </Typography>
                    </Button>
                } else {
                    let statuses = [RequestStatus.Submitted, RequestStatus.Pending]
                    if (statuses.includes(selectedOffer.status)) {
                        button = <Button mt={1} disabled={!selectedOffer.isValid} className={selectedOffer.isValid ? classes.buttonSubmit : classes.buttonDisabled} onClick={() => this.showRetractConfirmation()}>
                            <Typography className={classes.SidePanelButtonText}>{t('employeeSidePanel.buttons.retractRequest')}</Typography>
                        </Button>
                    }
                }
                break;
            default:
                break;
        }
        return button;
    }

    handleReceiveEmployeesError = (error) => {
        console.error('Error receiving employees:', error);
        if (error.message !== 'Operation was cancelled') {
            const isAuthError = error.message === 'Invalid authentication' ||
                (typeof error === 'string' && (error.includes('Unauthorized -') || error.includes('Invalid or expired token') || error.includes('Authentication required')));
            this.handleSnackbar('error', `Failed to load employees.${isAuthError ? ' Please login again.' : ''}`, true);
        }
        this.props.updateLoadingPrivateEmployeesValidation(false);
        this.props.updateLoadingPrivateEmployeesNames(false);
    }

    handleReceiveValidationError = (error) => {
        console.error('Error validating employees:', error);
        if (error.message !== 'Operation was cancelled') {
            const isAuthError = error.message === 'Invalid authentication' ||
                (typeof error === 'string' && (error.includes('Unauthorized -') || error.includes('Invalid or expired token') || error.includes('Authentication required')));
            this.handleSnackbar('error', `Failed to validate employees.${isAuthError ? ' Please login again.' : ''}`, true);
        }
        this.props.updateLoadingPrivateEmployeesValidation(false);
        this.props.updateLoadingPrivateEmployeesNames(false);
    }

    render() {
        const { classes, openSidePanel, sidePanelData } = this.props;

        return (
            <SideBar
                handleDrawerClose={() => this.resetSidePanel()}
                open={openSidePanel}
                className={classes.SideBar}
                title={<Typography className={classes.SideBarTitle}>{sidePanelData.label}</Typography>}
                isCloseOnOutsideClick={false}
            >
                {openSidePanel ? this.generateSidePanelContent(sidePanelData) : null}
            </SideBar>
        )
    }
}

const mapStateToProps = state => {
    return {
        openSidePanel: state.openSidePanel,
        storeData: state.data,
        person: state.person,
        options: state.httpOptions,
        managerSettings: state.managerSettings,
        managerSettingNames: state.managerSettingNames,
        sidePanelData: state.sidePanelData,
        employeesToOfferList: state.employeesToOfferList,//Do not remove, used in uiGenerators.wrapWithLeftRightGrid
        proposableShiftsPerEmployee: state.proposableShiftsPerEmployee,
        selectedProposableShiftsByOfferor: state.selectedProposableShiftsByOfferor,
        selectedActionIndex: state.selectedActionIndex,
        validProposalShifts: state.validProposalShifts,
        partialDates: state.partialDates,
        statusDictionary: state.statusDictionary,
        dateRanges: state.dateRanges,
        timeOffRequestSubtypes: state.timeOffRequestSubtypes,
        proposalPartialDates: state.proposalPartialDates,
        mobileProposalShiftsSelected: state.mobileProposalShiftsSelected,
        signalRConnection: state.signalRConnection,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeSidePanel: (payload) => dispatch(closeSidePanel(payload)),
        updateSidePanelData: (payload) => dispatch(updateSidePanelData(payload)),
        updateLoading: (payload) => dispatch(updateLoading(payload)),
        updateLoadingPrivateEmployeesValidation: (payload) => dispatch(updateLoadingPrivateEmployeesValidation(payload)),
        updateLoadingPrivateEmployeesNames: (payload) => dispatch(updateLoadingPrivateEmployeesNames(payload)),
        updateSnackbar: (payload) => dispatch(updateSnackbar(payload)),
        updateSelectedActionIndex: payload => dispatch(updateSelectedActionIndex(payload)),
        clearSelectedShifts: () => dispatch(clearSelectedShifts()),
        clearSelectedOpenShifts: () => dispatch(clearSelectedOpenShifts()),
        updateEmployeeToOfferList: payload => dispatch(updateEmployeeToOfferList(payload)),
        resetValidatedEmployeesToOfferList: () => dispatch(resetValidatedEmployeesToOfferList()),
        resetEmployeesToOfferList: () => dispatch(resetEmployeesToOfferList()),
        resetAndAddEmployeesToOfferList: payload => dispatch(resetAndAddEmployeesToOfferList(payload)),
        addOrUpdatevalidatedEmployeesToOfferList: payload => dispatch(addOrUpdatevalidatedEmployeesToOfferList(payload)),
        addOrUpdateEmployeesToOfferList: payload => dispatch(addOrUpdateEmployeesToOfferList(payload)),
        updateEmployeesToOfferList: payload => dispatch(updateEmployeesToOfferList(payload)),
        addPrivateEmployeeProposableShiftsList: payload => dispatch(addPrivateEmployeeProposableShiftsList(payload)),
        updatePartialDates: (payload) => dispatch(updatePartialDates(payload)),
        updateEmployeeDashboardData: (payload) => dispatch(updateEmployeeDashboardData(payload)),
        updateProposalPartialDates: (payload) => dispatch(updateProposalPartialDates(payload)),
        updateProposalShiftsSelected: payload => dispatch(updateProposalShiftsSelected(payload)),
    }
}

const ConnectedProps = connect(mapStateToProps, mapDispatchToProps);
const WithStylesAndTranslations = withTranslation('employmentBillboard')(withStyles(EmployeeDashboardStyles)(SidePanel));
export default ConnectedProps(WithStylesAndTranslations);
